











import Vue from 'vue'
import { Polyline as TripLine } from 'vue2-google-maps'

export default Vue.extend({
  name: 'Trips',
  components: { TripLine },
  props: {
    trips: Array
  }
})
